import { Injectable } from '@angular/core'
import { Observable, BehaviorSubject, throwError, catchError } from 'rxjs'
import { HttpClient } from '@angular/common/http'

@Injectable({
  providedIn: 'root',
})
export class TabServices extends BehaviorSubject<any[]> {
  private data: any[] = []
  constructor(private _http: HttpClient) {
    super([])
  }
  SubmitReviewsData(r: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Reviews/submitreviews`, r)
      .pipe(catchError(this.handleError))
  }
  SubmitNewAccountData(r: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Reviews/submitnewAccount`, r)
      .pipe(catchError(this.handleError))
  }
  handleError(error: any) {
    let errorMessage = ''
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`
    }
    return throwError(errorMessage)
  }
}
